export const workersComp = (name?: string, date?: string) => {
  return [
    { text: 'Workers Comp / Occupational Accident Coverage Waiver Form', style: 'h1' },

    { text: 'Independent Contractor Waiver of Worker Compensation / Occupational Accident Coverage', fontSize: 12, bold: true, alignment: 'center', margin: [0, 0, 0, 10] },

    { text:
        [
          { text: 'I ' },
          { text: ` ${name} `, bold: true },
          { text: 'an independent contractor, with no employees, no casual laborers, and no sub- contractors hauling loads for Sierra Expediting Inc. I am not an employee of Sierra Expediting Inc for workers compensation or occupational insurance purposes, and therefore. I am not entitled to workers compensation or occupational insurance benefits under their policy coverage. I waive any and all rights to file any claims against said carrier in event an accident should occur while I am hauling loads for a carrier.'}
        ],
      margin: [0, 10, 0, 20],
    },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: `${name}`, margin: [0,-20, 0, 0]},
    { text: "Contractor Name", style: 'label', margin: [0,2,0,0]},
    { text: "Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-28, 0, 0]},
    { text: "Date", style: 'label', margin: [340,2,0,0]},

    { text: '', pageBreak: 'before' },
  ];
};